import { OrganizationModel } from "../../entities";
import { BaseODataRepository } from "../BaseODataRepository";

export class OrganizationODataRepo extends BaseODataRepository<OrganizationModel> {
  protected baseUrl = `/odata/organizations`;
}

export default OrganizationODataRepo;
